<template>
  <div>
    <el-image
      v-if="imageurl"
      class="image-box"
      style="display: block; margin-bottom: 10px;"
      :src="imageurl"
      fit="contain"
    ></el-image>
    <input v-show="false" ref="ff" type="file" @change="onUplpad" />
    <el-input
      :disabled="true"
      :placeholder="placeholder"
      v-if="!isShowInput"
      v-model="imgFile"
      class="fixed-with-330-input"
    >
      <template slot="append">
        <el-button
          type="info"
          class="browse-button"
          @click="onSelectImageButton"
        >
          {{ buttonText }}</el-button
        >
      </template>
    </el-input>
    <el-button type="info" v-else class="browse-button" @click="onSelectImageButton"> {{ buttonText }}</el-button>
    <loadingDialog :centerDialogVisible="centerDialogVisible" loadingMsg="上傳中..."></loadingDialog>
  </div>
</template>

<script>
import loadingDialog from '@/components/loadingDialog'
import { getFileName } from '@/utils/is-rules'
import { file } from "@/api/files";
export default {
  components: {
    loadingDialog,
  },
  props: {
    fileType: {
      type: Array,
      default: () => {
        return ['png', 'jpg', 'gif', 'jpeg', 'bmp', 'webp', 'svg']
      }
    },
    imageurl: {
      type: String,
      default: "",
    },
    uploadUrl: {
      type: String,
      default: "/files",
    },
    buttonText: {
      type: String,
      default: "瀏覽",
    },
    placeholder: {
      type: String,
      default: "請選擇圖片",
    },
    isImgDom: {
      type: Boolean,
      default: false,
    },
    isShowInput: {
      type: Boolean,
      default: false,
    },
    isImgUpload: {
      type: Boolean,
      default: true,
    },
    isRectangle: {
      type: Boolean,
      default: false,
    },
  },
  watch:{
    imageurl:{
      handler(v){
        if(v!=null){
          this.imgFile = getFileName(v)
        }
      },
      deep:true,
      immediate:true
    }
  },
  data() {
    return {
      centerDialogVisible:false,
      imgFile:'',
      width: 1024,
      height: 600,
    };
  },
  methods: {
    onSelectImageButton() {
      this.$refs.ff.click();
    },
    onUplpad(e) {
      if (e.target.files[0].type != null) {
        this.imgFile = e.target.files[0].name
        var fileSize = e.target.files[0].size;
        var size = fileSize / 1024;
        const fileType = this.fileType
        const isFileType = fileType.includes(
          e.target.files[0].name.split('.').pop().toLowerCase()
        )
        const that = this;
        if (size > 307200) {
          that.$message.error(" up to 300MB");
          return false;
        }
        if (!isFileType && this.isImgUpload) {
          that.$message.error('文件格式错误，应为: jpeg,png,bmp,gif,svg,webp')
          return false
        }
        if (!isFileType && !this.isImgUpload) {
          that.$message.error('文件格式错误，应为: avi,wmv,mpeg,mp4,m4v,mov,asf,flv,f4v,rmvb,rm,3gp,vob.')
          return false
        }
        if (this.isImgDom) {
          this.isSize(e);
        } else {
          this.uploadFormData(e);
        }
      }
    },
    isSize(file) {
      let _URL = window.URL || window.webkitURL;
      let imgDom = new Image();
      const that = this;
      let imgFile = _URL.createObjectURL(file.target.files[0]);
      imgDom.src = imgFile;
      new Promise(function (resolve, reject) {
        imgDom.onload = () => {
          if (that.isRectangle) {
            if (imgDom.width / imgDom.height !== 8 / 3) {
              that.$message.warning(
                `需上传图片宽高比例为8：3,当前文件${imgDom.width}×${imgDom.height}`
              );
              reject();
            } else {
              resolve(true);
            }
          } else {
            if (imgDom.width / imgDom.height !== 1) {
              that.$message.warning(
                `需上传图片宽高比例为1：1,当前文件${imgDom.width}×${imgDom.height}`
              );
              reject();
            } else {
              resolve(true);
            }
          }
        };
      }).then(() => {
        this.uploadFormData(file);
      });
    },
    uploadFormData(e) {
      this.centerDialogVisible = true
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      file(this.uploadUrl, formData)
        .then((v) => {
          this.$emit("imgFile", this.imgFile);
          this.$emit("childByValue", v.data);
          this.$message({
            type: "success",
            message: "上傳成功!",
          });
        })
        .finally(() => {
          this.$refs.ff.value = null;
          this.centerDialogVisible = false
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-input-group {
    padding: 8px;
    border-radius: 10px;
    border: 1px solid #dcdfe6;
    background-color: #fff;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border: 1px solid #fff;
  }
  .el-input-group__append {
    border-radius: 10px;
  }
  .el-input-group__append button.el-button {
    background-color: #fcc03a;
    border-color: #fcc03a;
    color: #444;
    border-radius: 10px;
  }
}
</style>